import * as actionTypes from 'src/old/actions';

const filterEmployee = (allEmployees, employeeFromAction) =>
  allEmployees.filter(employee => employee.personalId !== employeeFromAction.personalId);

const unlockEmployee = (employeesPage, employeeFromAction) => {
  for (const employee of employeesPage) {
    if (employee.personalId === employeeFromAction.personalId) {
      employee.counter = 0;
    }
  }
  return employeesPage;
};
const initialState = {
  employees: {
    data: [],
    meta: {}
  },
  isLoading: undefined
};

const employeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EMPLOYEES: {
      return {
        ...state,
        employees: action.response
      };
    }

    case actionTypes.POST_EMPLOYEE: {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: [...state.employees.data, action.response]
        }
      };
    }
    case actionTypes.PUT_EMPLOYEE_STATUS: {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: [
            ...state.employees.data.filter(employee => employee.personalId !== action.response.employee.personalId),
            { ...action.response.employee, ...action.response.status }
          ]
        }
      };
    }
    case actionTypes.PUT_EMPLOYEE: {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: [...filterEmployee(state.employees.data, action.response), action.response]
        }
      };
    }
    case actionTypes.UNLOCK_EMPLOYEE: {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: unlockEmployee(state.employees.data, action.response)
        }
      };
    }
    case actionTypes.RESEND_ACTIVATION_EMPLOYEE: {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: [...filterEmployee(state.employees.data, action.response), action.response]
        }
      };
    }
    case actionTypes.START_LOADING_EMPLOYEES: {
      return {
        ...state,
        isLoading: true
      };
    }
    case actionTypes.END_LOADING_EMPLOYEES: {
      return {
        ...state,
        isLoading: false
      };
    }

    default: {
      return state;
    }
  }
};

export default employeesReducer;
